export default {
    PURE_NUMBER: 'NUMBPURE_NUMBERER',
    AREA_UNIT: 'AREA_UNIT',
    PRICE_UNIT: 'PRICE_UNIT',
    DATE_UNIT: 'DATE_UNIT',
    DISTANCE_UNIT: 'DISTANCE_UNIT',
    DISTANCE_METER_UNIT: 'DISTANCE_METER_UNIT',
};
